import { Lock } from "lucide-react";
import { usePaywallFilter } from "@/hooks/use-paywall-filter";

export function PaywallToggle({ showLabel = true }: { showLabel?: boolean }) {
  const { hidePaywall, toggle } = usePaywallFilter();

  return (
    <label className="inline-flex items-center gap-2 cursor-pointer select-none shrink-0">
      <span className="sr-only">Skjul artikler bag betalingsmur</span>
      <span className="relative inline-flex items-center">
        <input
          type="checkbox"
          className="sr-only peer"
          checked={hidePaywall}
          onChange={toggle}
          aria-label="Skjul artikler bag betalingsmur"
        />
        <span
          className={`
            relative inline-block h-[18px] w-[32px] rounded-full transition-colors duration-300
            ${hidePaywall ? "bg-bordeaux" : "bg-rule"}
          `}
          aria-hidden="true"
        >
          <span
            className={`
              absolute top-[2px] left-[2px] inline-block h-[14px] w-[14px] rounded-full bg-paper
              transition-transform duration-300 shadow-sm
              ${hidePaywall ? "translate-x-[14px]" : "translate-x-0"}
            `}
          />
        </span>
      </span>
      {showLabel && (
        <span className="inline-flex items-center gap-1 eyebrow text-ink-soft whitespace-nowrap">
          <Lock size={11} strokeWidth={1.5} />
          Skjul betalingsmur
        </span>
      )}
    </label>
  );
}
